import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  Polyline,
  InfoWindow,
  //Polygon
} from "@react-google-maps/api";
import Card from "@mui/material/Card";
import "./style.css";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Path } from "./googleMapLive";

function Map({
  paths,
  stops,
  homeLat,
  homeLng,
  workLat,
  workLng,
  currentlySelectedMarkerIndex,
}: {
  paths: Path[];
  stops: Path[];
  workLat: number;
  workLng: number;
  homeLat: number;
  homeLng: number;
  currentlySelectedMarkerIndex?: Path;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [positionIndex, setPositionIndex] = useState(0);
  const [selectedMarker, setSelectedMarker] = useState<number>(-1);
  const [selectedMarkerinfo, setSelectedMarkerinfo] = useState<number | null>(null);
  const [selectedMarkerinfowork, setSelectedMarkerinfowork] = useState<number | null>(null);


  const [selectedMarkermapStops, setSelectedMarkermapStops] = useState<number>(-1);

  const [selectedMarkermapPaths, setSelectedMarkermapPaths] = useState<number>(-1);

  const [loadingWorkAddress, setLoadingWorkAddress] = useState(true);
  const [loadingHomeAddress, setLoadingHomeAddress] = useState(true);
  const [homeAddress, setHomeAddress] = useState<string | null>(null);
  const [workAddress, setWorkAddress] = useState<string | null>(null);
  const googleMapApiKey = "AIzaSyAHzQG6CbgD3VdoChRyoYr8qbUm0ZRoBEg";
  let mapPaths: Path[] = paths;

  const mapStops: Path[] = stops;


  const icon1 = {
    url: "https://zypp.app/mailer/Map-icon.png",
    scaledSize: new window.google.maps.Size(35, 35),
    anchor: new window.google.maps.Point(20, 20),
    scale: 0,
  };

  const startLat = mapPaths[0].latitude;
  const startLng = mapPaths[0].longitude;
  const end = mapPaths.length - 1;
  const endPathLat = mapPaths[end].latitude;
  const endpathLng = mapPaths[end].longitude;

  const convertPathToLatLngLiteral = (
    path: Path[]
  ): google.maps.LatLngLiteral[] => {
    return path.map((point) => ({
      lat: point.latitude,
      lng: point.longitude,
      distance: point.Distance,
    }));
  };
  const [mapPath, setMapPath] = useState<google.maps.LatLngLiteral[]>([]);
  

  useEffect(() => {
    if (
      currentlySelectedMarkerIndex?.latitude !== mapStops[selectedMarkermapStops]?.latitude ||
      currentlySelectedMarkerIndex?.longitude !== mapStops[selectedMarkermapStops]?.longitude
    ) {
      // Find the index in the mapStops array where the coordinates match currentlySelectedMarkerIndex
      const newIndex = mapStops.findIndex(
        (e) =>
          currentlySelectedMarkerIndex?.latitude === e.latitude &&
          currentlySelectedMarkerIndex?.longitude === e.longitude
      );
  
      // Update the selectedMarker state with the new index
      setSelectedMarkermapStops(newIndex);

    }
  }, [currentlySelectedMarkerIndex, mapStops, selectedMarkermapStops]);
  useEffect(() => {
    if (
      currentlySelectedMarkerIndex?.latitude !== mapPaths[selectedMarkermapPaths]?.latitude ||
      currentlySelectedMarkerIndex?.longitude !== mapPaths[selectedMarkermapPaths]?.longitude
    ) {
      // Find the index in the mapStops array where the coordinates match currentlySelectedMarkerIndex
      const newIndex = mapPaths.findIndex(
        (e) =>
          currentlySelectedMarkerIndex?.latitude === e.latitude &&
          currentlySelectedMarkerIndex?.longitude === e.longitude
      );
  
      // Update the selectedMarker state with the new index
       setSelectedMarkermapPaths(newIndex);

      }
  }, [currentlySelectedMarkerIndex, mapStops, selectedMarkermapPaths, mapPaths]);
  
  useEffect(() => {
    const pathAsLatLngLiteral = convertPathToLatLngLiteral(paths);
    setMapPath(pathAsLatLngLiteral);
  }, [paths]);
  async function getLocality(
    apiKey: string,
    latitude: number | undefined,
    longitude: number | undefined
  ): Promise<string | null> {

    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch address. Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const result = data.results[0];
        // Extract the name of the first locality and sublocality if available
        const localityComponent = result.address_components.find(
          (component: any) => component.types.includes("sublocality_level_1")
        );
        const cityComponent = result.address_components.find((component: any) =>
          component.types.includes("locality")
        );
        const postalCodeComponent = result.address_components.find(
          (component: any) => component.types.includes("postal_code")
        );

        // Return the combined result of city, sublocality, and postal code if found
        if (localityComponent && cityComponent && postalCodeComponent) {
          const locality = localityComponent.long_name;
          const city = cityComponent.long_name;
          const postalCode = postalCodeComponent.long_name;
          return `${locality}, ${city}, ${postalCode}`;
        } else {
          // If any of the components is missing, return the formatted address
          return result.formatted_address;
        }
      } else {
        throw new Error(`No results found for the provided coordinates.`);
      }
    } catch (error: any) {
      console.error(`Error fetching locality: ${error.message}`);
      return null;
    }
  }
   useEffect(() => {
  const fetchData = async () => {
    try {
      const fetchedWorkAddress = await getLocality(
        googleMapApiKey,
        workLat,
        workLng
      );
      const fetchedHomeAddress = await getLocality(
        googleMapApiKey,
        homeLat,
        homeLng
      );

      setWorkAddress(fetchedWorkAddress);
      setLoadingWorkAddress(false);

      setHomeAddress(fetchedHomeAddress);
      setLoadingHomeAddress(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingWorkAddress(false);
      setLoadingHomeAddress(false);
    }
  };
 
    fetchData();
  }, [workLat, homeLat, homeLng, workLng]);

  useEffect(() => {
    let intervalId: NodeJS.Timer | undefined;
    if (isPlaying) {
      intervalId = setInterval(() => {
        setPositionIndex((prevIndex) => {
          if (prevIndex === mapPath.length - 1) {
            setIsPlaying(false); // Stop playing if reached the end
            clearInterval(intervalId);
            return prevIndex;
          }
          return prevIndex + 1;
        });
      }, 1000); // Adjust the interval time as needed
    }

    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
  }, [isPlaying, mapPath.length]);

  let iconMarkerStart = "https://zypp.app/clientdashboard-mailer/startpath.png";
  let iconMarkerEnd = "https://zypp.app/clientdashboard-mailer/endpath.png";

  const polylineOptionsBlue = {
    strokeColor: "#0826e5",
    strokeWeight: 2,
    strokeOpacity: 0.6,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    zIndex: 99999,
    icons: [
      {
        icon: {
          path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        },
        repeat: "40px",
        offset: "100%",
      },
    ],
  };
  const polylineOptions = {
    strokeColor: "#ffa500",
    strokeOpacity: 1,
    strokeWeight: 3,
    icons: [
      {
        icon: {
          path: window.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          scale: 3,
          fillColor: "#ffa500",
          fillOpacity: 1,
          strokeColor: "#ffa500",
        },
        offset: "100%",
      },
    ],
  };

 
 

  const handleNextMarker = () => {
    if (
      (selectedMarker === null || selectedMarker === mapStops.length - 1 )
      && 
      (selectedMarkermapStops === null || selectedMarkermapStops === mapStops.length - 1)
      ) {
      setSelectedMarker(0); // Wrap to the first marker if at the end
      setSelectedMarkermapStops(0); // Wrap to the first marker if at the end
    } else {
      setSelectedMarker(selectedMarker + 1);
      setSelectedMarkermapStops(selectedMarker + 1);
    }
  };

  const handlePreviousMarker = () => {
    if (
      (selectedMarker === null || selectedMarker === 0) &&
      (selectedMarkermapStops === null || selectedMarkermapStops === 0)
    ) {
      setSelectedMarker(mapStops.length - 1);
      setSelectedMarkermapStops(mapStops.length - 1); // Wrap to the last marker if at the beginning
    } else {
      setSelectedMarker(selectedMarker - 1);
      setSelectedMarkermapStops(selectedMarker - 1);
    }
  };
  const handleMarkerClick = (index: number) => {
    setSelectedMarker(index);
  };

  const handleMarkerHover = (e:any) => {
    setSelectedMarkerinfo(e);
};
const handleMarkerHoverWork = (e:any) => {
    setSelectedMarkerinfowork(e);
};

  function StopCircleIcon(stop: Path, index: number) {
    const markerColor = stop.time_diff <= "00:20:00" ? "orange" : "violet";

   

    return (
      <>
        <Marker
          key={stop.cycleId}
          position={{
            lat: stop.latitude,
            lng: stop.longitude,
          }}
          // icon={}
          icon={{
            path: "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z",
            anchor: new window.google.maps.Point(6, 8),
            fillOpacity: 1,
            strokeWeight: 2,
            strokeColor: "white",
            fillColor: markerColor,
            scale: 2,
            scaledSize: new google.maps.Size(50, 50), // scaled size
            labelOrigin: new window.google.maps.Point(12, 9),
          }}
          title={stop.cycleId.toString()}
          label={`${index + 1}`}
          onClick={() => handleMarkerClick(index)}
        >
          {(selectedMarker === index || selectedMarkermapStops === index) && (
  <InfoWindow>
    <div>
      {/* <p>
        <b>
          {stoptime1}-{stoptime2}
        </b>
      </p> */}
      <p>
        <b>Dur:</b> {stop.time_diff}
      </p>
      <div style={{ marginTop: "10px" }}>
        <button
          style={{
            zIndex: 9999999,
            backgroundColor: "#00CD5B",
            padding: 1,
          }}
          onClick={handlePreviousMarker}
        >
          <KeyboardArrowLeftIcon />
        </button>
        <button
          style={{
            zIndex: 9999999,
            marginLeft: 5,
            backgroundColor: "#00CD5B",
            padding: 1,
          }}
          onClick={handleNextMarker}
        >
          <KeyboardArrowRightIcon />
        </button>
      </div>
    </div>
  </InfoWindow>
)}

        </Marker>
      </>
    );
  }
  
  const homeMarker = {
    title: `Home: ${homeAddress || "Unknown Address"}\nLatitude: ${homeLat}\nLongitude: ${homeLng}\nGoogle Maps Link: https://maps.google.com/?q=${homeLat},${homeLng}`,
    icon: "/assets/hyper-track-icon/home-location.png", // Replace with the path to your home marker icon
    position: { lat: homeLat, lng: homeLng },
};

  const workMarker = {
    title: `Work: ${workAddress || "Unknown Address"}`,
    icon: "/assets/hyper-track-icon/work-location.png", // Replace with the path to your work marker icon
    position: { lat: workLat, lng: workLng },
  };
  return (
    <div>
      {/* <div style={{textAlign:'right', display:'flex', justifyContent:'flex-end'}}>
      <Button
            onClick={tooglePlay}
            style={{ backgroundColor: "#00CD5B", marginBottom: 10, color: "#fff" }}
          >
            {isPlaying ? "Pause" : "Play"}
          </Button>
          </div> */}
      <Card variant="outlined">
        <div className="gMapCont">
          <GoogleMap
           
            zoom={11}
            center={{ lat: workLat, lng: workLng }}
            options={{
              fullscreenControl: false,
              mapTypeControl: false,
              streetViewControl: false,
            }}
            // journeydetails={journeydetails}
            mapContainerStyle={{
              width: "100%",
              height: "44rem",
            }}
            
          >
            {!loadingHomeAddress && !loadingWorkAddress && (
              <>
                {/* Add markers for home and work */}
                <Marker
                title={homeMarker.title}
                icon={homeMarker.icon}
                position={homeMarker.position}
                onMouseOver={() => handleMarkerHover(workMarker)} // No semicolon needed here
            />

                  {selectedMarkerinfo !== null && (
            <>
              <InfoWindow
                position={homeMarker.position}
                options={{ pixelOffset: new window.google.maps.Size(0, -50) }}
                onCloseClick={() => setSelectedMarkerinfo(null)}
              >
                <div>
                  <p><b>Home: </b>{homeAddress || "Unknown Address"}</p>
                  <p><b>Latitude:</b> {homeLat} <b>Longitude:</b> {homeLng}</p>
                  <p>
                  <b>Google Maps Link:</b>  <a target="_blank" rel="noreferrer" href={`https://maps.google.com/?q=${homeLat},${homeLng}`}  style={{ cursor: "pointer", color:'blue' }}
                    >
                        https://maps.google.com/?q={homeLat},{homeLng}
                    </a>
                  </p>
                </div>
              </InfoWindow>
              
            </>
          )}
                 
                <Marker
                  title={workMarker.title}
                  icon={workMarker.icon}
                  position={workMarker.position}
                  onMouseOver={() => handleMarkerHoverWork(workMarker)} // No semicolon needed here

                >
                 {selectedMarkerinfowork !== null && (
            <>
              <InfoWindow
                position={workMarker.position}
                options={{ pixelOffset: new window.google.maps.Size(0, -50) }}
                onCloseClick={() => setSelectedMarkerinfowork(null)}
              >
                <div>
                  <p><b>Work: </b>{workAddress || "Unknown Address"}</p>
                  <p><b>Latitude:</b> {workLat} <b>Longitude:</b> {workLng}</p>
                  <p>
                  <b>Google Maps Link:</b>  <a target="_blank" rel="noreferrer" href={`https://maps.google.com/?q=${workLat},${workLng}`}  style={{ cursor: "pointer", color:'blue' }}
                    >
                        https://maps.google.com/?q={workLat},{workLng}
                    </a>
                  </p>
                </div>
              </InfoWindow>
              
            </>
          )}
          </Marker>
              </>
            )}



            <Polyline path={mapPath} options={polylineOptionsBlue} />
            {mapStops && mapStops && (
              <>
                {mapStops.map((stop: any, index: number) =>
                  StopCircleIcon(stop, index)
                )}
              </>
            )}

            {mapPath && (
              <>
                <Polyline
                  path={mapPath.slice(0, positionIndex + 1)}
                  options={polylineOptions}
                />

                <Marker icon={icon1} position={{ lat: 0, lng: 0 }} />
              </>
            )}
            <Marker
              // label={new window.google.maps.Label("")}
              icon={iconMarkerStart}
              position={{ lat: startLat, lng: startLng }}
            />
            <Marker
              // name={"SOMA"}
              icon={iconMarkerEnd}
              position={{ lat: endPathLat, lng: endpathLng }}
            />
          </GoogleMap>
        </div>
      </Card>
    </div>
  );
}

// const WrappedMap = withScriptjs(withGoogleMap(Map));

export default Map;
